window.addEventListener('load', function () {
  if (typeof Weglot !== 'undefined' && typeof klaviyo !== 'undefined') {
    const lang = Weglot.getCurrentLang();    
    klaviyo.push(['identify', { lang: lang }]);
  }
});